module.exports = __webpack_public_path__ + "static/male-chiropractor-physical-therapist-shaking-hands-68e4030c70e1d85cdbf0bff550e2f907.webp";